export const TIME_HUD_GUI_ID = "rpg-time-hud";

export const TIME_HUD_I18N = {
  en: {
    "rpg.time.day": "Day {day}",
    "rpg.time.hud": "Day {day}, {time}, {phase}",
    "rpg.time.phase.night": "night",
    "rpg.time.phase.dawn": "dawn",
    "rpg.time.phase.day": "day",
    "rpg.time.phase.dusk": "dusk",
  },
  fr: {
    "rpg.time.day": "Jour {day}",
    "rpg.time.hud": "Jour {day}, {time}, {phase}",
    "rpg.time.phase.night": "nuit",
    "rpg.time.phase.dawn": "aube",
    "rpg.time.phase.day": "jour",
    "rpg.time.phase.dusk": "crépuscule",
  },
};
